import { Fragment, jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import classnames from "classnames";
import { useStyles } from "./Avatar.styles.js";
const Avatar_Avatar = (props)=>{
    const $ = c(15);
    const { variant: t0, withBadge, size: t1, children, loadPhoto, alt, src: url } = props;
    const variant = void 0 === t0 ? "circle" : t0;
    const size = void 0 === t1 ? "medium" : t1;
    const { classes } = useStyles();
    const [src, setSrc] = useState(url);
    let t2;
    let t3;
    if ($[0] !== url) {
        t2 = ()=>{
            setSrc(url);
        };
        t3 = [
            url
        ];
        $[0] = url;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    useEffect(t2, t3);
    let t4;
    let t5;
    if ($[3] !== loadPhoto || $[4] !== src) {
        t4 = ()=>{
            if (!src) null == loadPhoto || loadPhoto().then((blob)=>{
                setSrc(URL.createObjectURL(blob));
            }).catch(_temp);
        };
        t5 = [
            loadPhoto,
            src
        ];
        $[3] = loadPhoto;
        $[4] = src;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    useEffect(t4, t5);
    let t6;
    if ($[7] !== alt || $[8] !== children || $[9] !== classes || $[10] !== size || $[11] !== src || $[12] !== variant || $[13] !== withBadge) {
        t6 = withBadge ? /*#__PURE__*/ jsx(Badge, {
            className: `aqa_avatar_badge ${classes.badge}`,
            overlap: "circular",
            variant: "dot",
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "right"
            },
            children: /*#__PURE__*/ jsx(Avatar_Avatar, {
                className: classnames("aqa_avatar", "square" === variant && classes.avatarSquare),
                alt: alt,
                children: children,
                src: src,
                size: size
            })
        }) : /*#__PURE__*/ jsx(Avatar, {
            src: src,
            alt: alt,
            children: src ? /*#__PURE__*/ jsx(Fragment, {}) : children,
            "data-testid": "avatar",
            className: classnames("aqa_avatar", classes.avatar, classes[size], "square" === variant && classes.avatarSquare)
        });
        $[7] = alt;
        $[8] = children;
        $[9] = classes;
        $[10] = size;
        $[11] = src;
        $[12] = variant;
        $[13] = withBadge;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
};
function _temp() {}
export { Avatar_Avatar as Avatar };
